import { useState, useEffect } from 'react';

function useIsSmallScreen(screenSize) {
  // Initialize state with the current match result
  const [isSmallScreen, setIsSmallScreen] = useState(
    () => window.matchMedia(`(max-width: ${screenSize}px)`).matches
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia(`(max-width: ${screenSize}px)`);

    const handleMediaChange = (event) => {
      setIsSmallScreen(event.matches);
    };

    mediaQuery.addEventListener('change', handleMediaChange);

    return () => {
      mediaQuery.removeEventListener('change', handleMediaChange);
    };
  }, []);

  return isSmallScreen;
}

export default useIsSmallScreen;
